import React, { useState } from 'react'
import './styles/app.scss'
import Header, { HeaderPhone } from './components/Header'
import Home from './components/Home'
import Work from './components/Work'
import TimeLine from './components/TimeLine.jsx'
import Services from './components/Services'
// import Testimonial from './components/Testimonial'
import Contact from './components/Contact'
import Footer from './components/Footer.jsx'

import { Toaster } from 'react-hot-toast'

const App = () => {

  const [menuOpen,setMenuOpen] = useState(false)
  console.log(menuOpen)
  return (
    <>
      <HeaderPhone menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      <Home/>
      <Work/>
      <TimeLine/>
      <Services/>
      {/* <Testimonial/> */}
      <Contact/>
      <Footer/>
      <Toaster/>
    </>
  )
}

export default App
